import { z } from "zod";

/**
 * The Smart Action popup's URL key (`?smartActionId=<id>`), a shadow route
 * (`docs/webapp/use-query-state.md` § Shadow routes): the popup opens over
 * whatever page holds the key, and closing it removes only the key, so the
 * page underneath stays as it was — an order stays the order, the board stays
 * the board.
 */
export const SMART_ACTION_SHADOW_PARAM = "smartActionId";

/**
 * Spread into the `validateSearch` of every route that opens the popup: a key
 * the route does not declare is stripped on parse, and the opener appears to do
 * nothing. Lenient, like every URL key (`.claude/rules/webapp-routing.md`).
 */
export const smartActionShadowSearchFragment = {
  [SMART_ACTION_SHADOW_PARAM]: z.string().optional().catch(undefined),
};
